import apiClient from './apiClient';

export async function initializeCompany({ companyName, adminFullName, adminEmail, adminPassword }) {
  const res = await apiClient.post('/setup/initialize', {
    companyName,
    adminFullName,
    adminEmail,
    adminPassword,
  });
  return res.data.data; // { company, admin }
}
